
import ProductFunctions from '~/mixins/ProductFunctions'

export default {
  mixins: [ProductFunctions],

  props: {
    data: {
      type: Object,
      required: true,
    },

    bgWhite: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,
    }
  },
}
